type NextPageTriggerProps = {
  ref: (el: Element | null) => void;
};

export const NextPageTrigger = (props: NextPageTriggerProps) => {
  return (
    <div ref={props.ref}>
      <span style={{ fontSize: 1 }}>&nbsp;</span>
    </div>
  );
};
